import React, { Component } from 'react';
import AuthService from '../services/auth';
import Api from '../services/api';
import InputRange from 'react-input-range';
import Pagination from '../components/pagination';
import { withRouter } from 'react-router-dom';
import 'react-input-range/lib/css/index.css';
import './search.css';
import '../components/Fields.css';
import UserListEntry from '../components/UserListEntry';
import withAuthorization from '../components/withAuthorization';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import chevron from '../static/vectors/chevron.svg';
import * as routes from '../constants/routes';
import Select from 'react-select';
import countries from '../constants/countries';
import Cookies from 'js-cookie';
import GoogleAd from 'react-google-ad';

class Search extends Component {

  constructor(props) {
    super(props);

    let filter = {
      page: 1,
      countries: [],
      extra: [],
      bodyType: [],
      ageRange: {
        min: 18,
        max: 60,
      },
      ethnicity: [],
      height: {
        min: 137,
        max: 210,
      },
      relationship: [],
      lifestyleExpectations: [],
      searchText: '',
    };

    if(typeof Cookies.get('searchFilter') !== 'undefined') {
      filter = Cookies.getJSON('searchFilter');
    }

    this.state = {
      filter,
      users: [],
      openFilters: [],
      optionsCountries: [],
    }
  }

  componentDidMount() {
    const { setCurrentPage } = this.props;
    if(!AuthService.isLoggedIn()) {
      this.props.history.push(routes.JOIN);
    } else {
      this.refreshCountryOptions();
      this.filterPosts();
      setCurrentPage(routes.SEARCH);
    }
  }

  refreshCountryOptions() {
    const { ucdUser } = this.props;

    (new Api()).get('/availableCountries', { sex: ucdUser.sex, lookingFor: ucdUser.lookingFor, }, AuthService.getAuthCookie())
      .then(response => {

        let optionsCountries = [];
        countries.map(country => {
          if (response.countries.includes(country.code)) {
            optionsCountries.push({
              value: country.code,
              label: country.name,
            });
          }
          return country;
        });
        this.setState({
          optionsCountries,
        });
      });
  }

  setInitialState() {
    this.setState({
      filter: {
        page: 1,
        countries: [],
        extra: [],
        bodyType: [],
        ageRange: {
          min: 18,
          max: 60,
        },
        ethnicity: [],
        height: {
          min: 137,
          max: 210,
        },
        relationship: [],
        lifestyleExpectations: [],
        searchText: '',
      },
      openFilters: [],
      optionsCountries: [],
    }, () => {
      this.refreshCountryOptions();
      this.filterPosts();
      Cookies.set('searchFilter',this.state.filter, { expires: 365});
    });
  }

  filterPosts() {
    const { filter } = this.state;
    (new Api()).get('/users', filter, AuthService.getAuthCookie())
      .then(response => {
        this.setState({
          users: response.users,
          total: response.total,
          limit: response.limit,
        });
      });
  }

  handleFilterChange(e, name) {
    let { errors, filter } = this.state;
    if(e.target.type === 'checkbox') {
      if(e.target.checked) {
        if (!filter[name].includes(e.target.value)) {
          filter[name].push(e.target.value);
        }
      } else {
        const index = filter[name].indexOf(e.target.value);
        if (index > -1) {
          filter[name].splice(index, 1);
        }
      }

      this.setState({ filter, errors }, () => {
        this.filterPosts()
      });
    } else {
      filter[name] = e.target.value;
      this.setState({ filter, errors });
    }
    Cookies.set('searchFilter',filter, { expires: 365})
  }

  handleCountryChange(location) {
    let { filter } = this.state;

    filter.countries = location;
    this.setState({
      filter,
    }, () => {
      this.filterPosts();
    });
    Cookies.set('searchFilter',filter, { expires: 365});
  }

  handleRangeChange(value, name) {
    let { filter } = this.state;
    filter[name] = value;

    this.setState({
      filter,
    });
    Cookies.set('searchFilter',filter, { expires: 365});
  }

  toggleFilter(name) {
    const { openFilters } = this.state;
    if(openFilters.includes(name)) {
      const i = openFilters.indexOf(name);
      openFilters.splice(i, 1);
    } else {
      openFilters.push(name);
    }

    this.setState({
      openFilters,
    });
  }

  handlePageChange(page) {
    let { filter } = this.state;
    filter.page = page;
    this.setState({filter}, () => {
      this.filterPosts();
    });
    Cookies.set('searchFilter',filter, { expires: 365});
  }

  toggleFavourite(user, value) {
    const { authUser, onSetAuthUser } = this.props;
    if(value) {
      (new Api()).post('/favourites', {targetId: user}, AuthService.getAuthCookie())
        .then(() => {
          (new Api()).get('/users/current', {}, AuthService.getAuthCookie())
            .then(response => {
              onSetAuthUser(authUser, response.user);
            });
        });
    } else {
      (new Api()).remove('/favourites', {targetId: user}, AuthService.getAuthCookie())
        .then(() => {
          (new Api()).get('/users/current', {}, AuthService.getAuthCookie())
            .then(response => {
              onSetAuthUser(authUser, response.user);
            });
        });
    }
  }

  render() {
    const { filter, users, openFilters, optionsCountries, total, limit } = this.state;
    const { ucdUser } = this.props;
    return (
      <div className="container search">
        {AuthService.isLoggedIn() && <div className="row">

          <div className="col col-12 col-md-3 filter">
            <div className="filter-title">
              Search
            </div>
            <div className="button-container">
              <button
                className="btn clear"
                onClick={() => this.setInitialState()}
              >
                Clear filters
              </button>
            </div>
            <div className="field-container select country">
              <Select
                name="country"
                multi
                onChange={value => this.handleCountryChange(value)}
                options={optionsCountries}
                placeholder="Choose country"
                value={filter.countries}
                simpleValue
                removeSelected
                clearable
              />
            </div>
            <div className="field-container checkbox">
              <div
                className="field-title"
                onClick={() => { this.toggleFilter('bodyType'); }}
              >
                Body Type
                <img
                  src={chevron}
                  className={`${(openFilters.includes('bodyType'))?'open':''}`}
                  onClick={() => { this.toggleFilter('bodyType'); }}
                  alt="chevron" />
              </div>
              <div className={`row ${(openFilters.includes('bodyType'))?'open':''}`}>
                <div className="col">
                  <input
                    type="checkbox"
                    id="bodyTypeSlim"
                    name="bodyType"
                    checked={filter.bodyType.includes('slim')}
                    value="slim"
                    onChange={e => {this.handleFilterChange(e, e.target.name)}}
                  />
                  <label className="field-title" htmlFor="bodyTypeSlim">slim</label>
                  <input
                    type="checkbox"
                    id="bodyTypeAthletic"
                    name="bodyType"
                    checked={filter.bodyType.includes('athletic')}
                    value="athletic"
                    onChange={e => {this.handleFilterChange(e, e.target.name)}}
                  />
                  <label className="field-title" htmlFor="bodyTypeAthletic">athletic</label>
                  <input
                    type="checkbox"
                    id="bodyTypeCurvy"
                    name="bodyType"
                    checked={filter.bodyType.includes('curvy')}
                    value="curvy"
                    onChange={e => {this.handleFilterChange(e, e.target.name)}}
                  />
                  <label className="field-title" htmlFor="bodyTypeCurvy">curvy</label>
                </div>
              </div>
            </div>
            <div className="field-container checkbox">
              <div
                className="field-title"
                onClick={() => { this.toggleFilter('extra'); }}
              >
                Extra
                <img
                  src={chevron}
                  className={`${(openFilters.includes('extra'))?'open':''}`}
                  onClick={() => { this.toggleFilter('extra'); }}
                  alt="chevron" />
              </div>
              <div className={`row ${(openFilters.includes('extra'))?'open':''}`}>
                <div className="col">
                  <input
                    type="checkbox"
                    id="extraFavourited"
                    name="extra"
                    checked={filter.extra.includes('favourited')}
                    value="favourited"
                    onChange={e => {this.handleFilterChange(e, e.target.name)}}
                  />
                  <label className="field-title" htmlFor="extraFavourited">favourited by me</label>
                  <input
                    type="checkbox"
                    id="extraFavouritedBy"
                    name="extra"
                    checked={filter.extra.includes('favouritedBy')}
                    value="favouritedBy"
                    onChange={e => {this.handleFilterChange(e, e.target.name)}}
                  />
                  <label className="field-title" htmlFor="extraFavouritedBy">favourited me</label>
                </div>
              </div>
            </div>
            <div className="field-container range">
              <div
                className={`field-title ${(openFilters.includes('ageRange'))?'open':''}`}
                onClick={() => { this.toggleFilter('ageRange'); }}
              >
                Age
                <img
                  src={chevron}
                  className={`${(openFilters.includes('ageRange'))?'open':''}`}
                  onClick={() => { this.toggleFilter('ageRange'); }}
                  alt="chevron" />
              </div>
              <div className={`row ${(openFilters.includes('ageRange'))?'open':''}`}>
                <div className="col">
                  <InputRange
                    value={filter.ageRange}
                    minValue={18}
                    maxValue={60}
                    minRange={18}
                    maxRange={60}
                    onChange={(value)=>{
                      this.handleRangeChange(value, 'ageRange')
                    }}
                    onChangeComplete={() => {this.filterPosts()}}
                    step={1}
                  />
                </div>
              </div>
            </div>
            <div className="field-container checkbox">
              <div
                className="field-title"
                onClick={() => { this.toggleFilter('ethnicity'); }}
              >
                Ethnicity
                <img
                  src={chevron}
                  className={`${(openFilters.includes('ethnicity'))?'open':''}`}
                  onClick={() => { this.toggleFilter('ethnicity'); }}
                  alt="chevron" />
              </div>
              <div className={`row ${(openFilters.includes('ethnicity'))?'open':''}`}>
                <div className="col">
                  <input
                    type="checkbox"
                    id="ethnicityAfrican"
                    name="ethnicity"
                    checked={filter.ethnicity.includes('african')}
                    value="african"
                    onChange={e => {this.handleFilterChange(e, e.target.name)}}
                  />
                  <label className="field-title" htmlFor="ethnicityAfrican">african</label>
                  <input
                    type="checkbox"
                    id="ethnicityAsian"
                    name="ethnicity"
                    checked={filter.ethnicity.includes('asian')}
                    value="asian"
                    onChange={e => {this.handleFilterChange(e, e.target.name)}}
                  />
                  <label className="field-title" htmlFor="ethnicityAsian">asian</label>
                  <input
                    type="checkbox"
                    id="ethnicityCaucsian"
                    name="ethnicity"
                    checked={filter.ethnicity.includes('caucasian')}
                    value="caucasian"
                    onChange={e => {this.handleFilterChange(e, e.target.name)}}
                  />
                  <label className="field-title" htmlFor="ethnicityCaucsian">caucasian</label>
                  <input
                    type="checkbox"
                    id="ethnicityLatin"
                    name="ethnicity"
                    checked={filter.ethnicity.includes('latin')}
                    value="latin"
                    onChange={e => {this.handleFilterChange(e, e.target.name)}}
                  />
                  <label className="field-title" htmlFor="ethnicityLatin">latin</label>
                  <input
                    type="checkbox"
                    id="ethnicityMiddleEastern"
                    name="ethnicity"
                    checked={filter.ethnicity.includes('middle_eastern')}
                    value="middle_eastern"
                    onChange={e => {this.handleFilterChange(e, e.target.name)}}
                  />
                  <label className="field-title" htmlFor="ethnicityMiddleEastern">middle eastern</label>
                </div>
              </div>
            </div>
            <div className="field-container range">
              <div
                className={`field-title ${(openFilters.includes('height'))?'open':''}`}
                onClick={() => { this.toggleFilter('height'); }}
              >
                Height
                <img
                  src={chevron}
                  className={`${(openFilters.includes('height'))?'open':''}`}
                  onClick={() => { this.toggleFilter('height'); }}
                  alt="chevron" />
              </div>
              <div
                className={`row ${(openFilters.includes('height'))?'open':''}`}>
                <div className="col">
                  <InputRange
                    value={filter.height}
                    minValue={137}
                    maxValue={210}
                    minRange={137}
                    maxRange={210}
                    onChange={(value)=>{
                      this.handleRangeChange(value, 'height')
                    }}
                    onChangeComplete={() => {this.filterPosts()}}
                    step={1}
                  />
                </div>
              </div>
            </div>
            <div className="field-container checkbox">
              <div className="field-title">Relationship status
                <img
                  src={chevron}
                  className={`${(openFilters.includes('relationship'))?'open':''}`}
                  onClick={() => { this.toggleFilter('relationship'); }}
                  alt="chevron" />
              </div>
              <div
                className={`row ${(openFilters.includes('relationship'))?'open':''}`}>
                <div className="col">
                  <input
                    type="checkbox"
                    id="relationshipSingle"
                    name="relationship"
                    checked={filter.relationship.includes('single')}
                    value="single"
                    onChange={e => {this.handleFilterChange(e, e.target.name)}}
                  />
                  <label className="field-title" htmlFor="relationshipSingle">single</label>
                  <input
                    type="checkbox"
                    id="relationshipOpenRelationship"
                    name="relationship"
                    checked={filter.relationship.includes('openRelationship')}
                    value="openRelationship"
                    onChange={e => {this.handleFilterChange(e, e.target.name)}}
                  />
                  <label className="field-title" htmlFor="relationshipOpenRelationship">Open Relationship</label>
                </div>
              </div>
            </div>
            <div className="field-container checkbox">
              <div className="field-title">Lifestyle expectation
                <img
                  src={chevron}
                  className={`${(openFilters.includes('lifestyleExpectations'))?'open':''}`}
                  onClick={() => { this.toggleFilter('lifestyleExpectations'); }}
                  alt="chevron" />
              </div>
              <div
                className={`row ${(openFilters.includes('lifestyleExpectations'))?'open':''}`}>
                <div className="col">
                  <input
                    type="checkbox"
                    id="lifestyleExpectationsNegotiable"
                    name="lifestyleExpectations"
                    checked={filter.lifestyleExpectations.includes('negotiable')}
                    value="negotiable"
                    onChange={e => {this.handleFilterChange(e, e.target.name)}}
                  />
                  <label className="field-title" htmlFor="lifestyleExpectationsNegotiable">negotiable</label>
                  <input
                    type="checkbox"
                    id="lifestyleExpectationsModerate"
                    name="lifestyleExpectations"
                    checked={filter.lifestyleExpectations.includes('moderate')}
                    value="moderate"
                    onChange={e => {this.handleFilterChange(e, e.target.name)}}
                  />
                  <label className="field-title" htmlFor="lifestyleExpectationsModerate">moderate</label>
                  <input
                    type="checkbox"
                    id="lifestyleExpectationsHigh"
                    name="lifestyleExpectations"
                    checked={filter.lifestyleExpectations.includes('high')}
                    value="high"
                    onChange={e => {this.handleFilterChange(e, e.target.name)}}
                  />
                  <label className="field-title" htmlFor="lifestyleExpectationsHigh">high</label>
                </div>
              </div>
            </div>
            <div className="field-container text">
              <div className="field-title">Profile text
                <img
                  src={chevron}
                  className={`${(openFilters.includes('searchText'))?'open':''}`}
                  onClick={() => { this.toggleFilter('searchText'); }}
                  alt="chevron" />
              </div>
              <div
                className={`row ${(openFilters.includes('searchText'))?'open':''}`}>
                <div className="col">
                  <input
                    type="text"
                    id="searchText"
                    name="searchText"
                    placeholder="e.g. dining, shopping, clubbing"
                    value={filter.searchText}
                    onChange={e => {this.handleFilterChange(e, e.target.name)}}
                    onBlur={() => {this.filterPosts()}}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col col-12 col-md-9 list">
            <div className="row">
              <div className="col col-12 user">
                {users.map((user, i) => (
                    <UserListEntry
                      key={i}
                      user={user}
                      isFavourited={ucdUser.hasFavourited.includes(user.id)}
                      onFavourite={(user, value) => {this.toggleFavourite(user, value)}}
                      onClick={() => {this.props.history.push(`/member/${user.name}`)}}
                    />
                ))}
              </div>
              <Pagination totalPages={Math.ceil(total / limit)} currentPage={filter.page} onPageChange={(selected) => {this.handlePageChange(selected)}}/>
            </div>
            <div className="row">
              <div className="col col-12 text-align-center">
                {ucdUser && ucdUser.status <= 3 && <GoogleAd client="ca-pub-2888386750549640" slot="1116128012" format="auto" />}
              </div>
            </div>
          </div>
        </div>}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ucdUser: state.sessionState.ucdUser,
  authUser: state.sessionState.authUser,
});

const mapDispatchToProps = (dispatch) => ({
  onSetAuthUser: (authUser, ucdUser) => dispatch({ type: 'AUTH_USER_SET', authUser, ucdUser }),
  setCurrentPage: (page) => dispatch({ type: 'SET_CURRENT_PAGE', page }),
});

const authCondition = (authUser) => !!authUser;

export default compose(
  withAuthorization(authCondition),
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(Search);


// WEBPACK FOOTER //
// ./src/pages/search.js